import defaultImage from "@/assets/img/svg/default-image.svg";

/**
 *
 * @param {Product|BasketProduct} product
 * @param {ProductPrice|null} productPrice
 * @return {{name: string, params: {slug: string}, meta: {value: number}}}
 */
export function routeToProduct(product, productPrice = null) {
    let value = productPrice?.value || product.productPrices?.data[0]?.value;

    return {
        name: "card",
        params: {
            slug: product.slug,
        },
        meta: {
            value: value,
        },
    };
}
/**
 *
 * @param {Product|BasketProduct} product
 * @param {ProductPrice|null} productPrice
 * @return {string|null}
 */
export function resolveProductImage(product, productPrice = null) {
    return (
        productPrice?.image ||
        product?.select_type?.image ||
        product?.productPrices?.data[0]?.image ||
        product.image ||
        defaultImage
    );
}

/**
 *
 * @param {Product|BasketProduct} product
 * @param {ProductPrice|null} productPrice
 * @return {string|null}
 */
export function resolveHoverProductImage(product, productPrice = null) {
    return (
        productPrice?.image2 || product?.select_type?.image2 || product?.productPrices?.data[0]?.image2 || product.image2
    );
}

/**
 * @param {ProductPrice} productPrice
 * @return {string}
 */
export function getProductPriceTitle(productPrice) {
    return productPrice.title || productPrice.value;
}

/**
 * @param {PayloadProductWithCount} products
 * @return {string}
 */
export function generateProductWithCountQuery(products, additionalQuery = '') {
    const query =  products.map((product, index) => {
        return `ids[${index}][id]=${product.id}&ids[${index}][count]=${product.select_count}`;
    }).join("&");

    return `${additionalQuery}&${query}`;
}
